"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var constants_1 = require("containers/App/constants");
var SidebarGroup_1 = __importDefault(require("containers/Sidebar/SidebarGroup"));
var SidebarSection_1 = __importDefault(require("containers/Sidebar/SidebarSection"));
var single_1 = require("utils/selectors/single");
var RecharglySidebar = function () {
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var menuRecharges = react_1.default.useMemo(function () { return (0, constants_1.GET_MENU_RECHARGES)(rechargerCompany !== null && rechargerCompany !== void 0 ? rechargerCompany : undefined, profile.isAdmin); }, [rechargerCompany]);
    return ((0, jsx_runtime_1.jsx)(SidebarSection_1.default, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 2 }, { children: (0, jsx_runtime_1.jsx)(SidebarGroup_1.default, { menuItems: menuRecharges }) })) }));
};
exports.default = RecharglySidebar;
